import { Component, OnInit ,ViewChild} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext,WebResponesContext } from '../../../../model/common';
// import { NavController,Platform, IonInfiniteScroll } from '@ionic/angular';
import{ NavController,IonInfiniteScroll, ActionSheetController,AlertController,Events,IonTabs,MenuController,ModalController,Platform,PopoverController} from '@ionic/angular';

import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';

import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import {PublicselectionPage} from '../../../publicselection/publicselection.page';
import { ListofActivitiesPage } from '../../listof-activities/listof-activities.page'
declare var app;
@Component({
  selector: 'app-a2-natural-distribution',
  templateUrl: './a2-natural-distribution.component.html',
  styleUrls: ['./a2-natural-distribution.component.scss']
})
export class A2NaturalDistributionComponent extends GridBaseCase {

  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:string = null;
  Remark:string = null;
  oldNum:string = null; 
  step: number = 1;
  num : any = 0;
  allnumber: any = '全部';
  allcnter: boolean = false;
  allnumber1: any = '全部';
  allcnter1: boolean = false;
  allnumber2: any = '全部';
  allcnter2: boolean = false;
  searchValue:string = null;//查询内容
  haveDate: boolean = false; //日期/角色 列表数据显示与否
  buType:any;
  tempGridList:Array<any>=new Array<any>();//礼品/样品列表
  lpArrayList:Array<any>=[];//新礼品列表
  ischeckAll:boolean=false;//礼品是否返回权限
  DisabledSubmit: boolean = false;
  activityListArray:Array<any> = new Array<any>();//活动名称列表
  activityName:any="请选择活动";
  activityID:string=null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    public modalCtrl:ModalController,
    private msg: MessageclientService,
    public native: NativeService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.month = this.com.getNow;

    // let codeRose= this.com.GetAccount.Roles;
    // console.log("角色角色角色角色===============================")
    // console.log(codeRose)
    // console.log(codeRose[0].Code);
    // let codeDetail = codeRose[0].Code;
      // if(codeDetail === "1002"){
        this.baseService.FixedSubmitBtn.configName = "NaturalDistribution";
        this.baseService.FixedSubmitBtn.isShow = true;
        this.baseService.FixedSubmitBtn.text = "提交";
        this.baseService.FixedSubmitBtn.type = 1;
        console.log("角色为snc")
      // }
      let accbutype = this.com.GetStorageKey("account");
      console.log("身份显示")
      console.log(accbutype.BuType);
      this.buType = accbutype.BuType;
    this.BindActivityInfo();// 加载活动表

  }

  /**
   * 文本框获取焦点事件
   * @param item 当前列数据
   */
  getFocus(item){
    this.oldNum = item.orderVolume.value;
  }
  /**
   * 
   * @param e 
   * @param type 
   */
    subClick(type){
      const that =this;
      let arrayDataList:Array<any> = new Array<any>();
    console.log(that.dataArrayList,"数据");
    let moreZero =0;
      for (let i=0;i<that.dataArrayList.length;i++) {
        if(that.dataArrayList[i]["orderVolume"].value>0) {
          console.log("dataArrayList IS");
          moreZero =1;
          continue;
        }
      }
      if (moreZero > 0){
        // 有修改，弹框
        // that.msg.Show("我有修改，可以弹框了");
        that.msg.Confirm("您有修改的数据未提交,点击取消将清空","取消","确定","",false).then(fail=>{
          if(fail){
                let arrayDataList:Array<any> = new Array<any>();
                console.log(that.dataArrayList,"数据");
                // return;
                that.dataArrayList.forEach(items=>{
                  let c={};
                  if(items["orderVolume"].value){//产品数量
                    c["ID"]=items["id"].value;
                    c["Count"]=items["orderVolume"].value;
                    arrayDataList.push(c);
                  }
                });
               
              if(arrayDataList.length<=0){
                that.msg.Alert("必须填写自然销量");
                that.baseService.FixedSubmitBtn.isSubmitData = true;
                return;
              }
              const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
              let body = new WebParameterContext();
              body.Account = that.com.GetAccount;
              body.ConfigName = "NaturalSales";
              body.OpType = "EDITE";
              body.ConfigType = "view";
              body.RowsPerPage = app.RowsPerPage;
              body.PageNumber = 0;
              body.Client.PageName = PageName;
              body.Client.ApiType = "Element";
              body.Client.Name = that.element.name;
              body.Client.ClientType = 2;
              if (that.platform.is("android")) {
                body.Client.ClientType = 0;
              } else if (that.platform.is("ios")) {
                body.Client.ClientType = 1;
              }
              // body.RequestBody = {"Products":JSON.stringify(arrayDataList)};
              body.RequestBody = {"Products":arrayDataList};
              body.RequestBody["Createtime"]=that.month;//获取当前日期
              
              body.RequestBody = JSON.stringify(body.RequestBody);
              //  return;
              that.baseService.FixedSubmitBtn.isSubmitData = true;
                that.msg.Confirm("确定提交吗？","取消","确定","",false).then(res=>{
                  if(res){
                    that.http.post(app.DEFAULTURL, body).then(data => {
                      that.baseService.FixedSubmitBtn.isSubmitData = true;
                      /****判断是否第一页end****/
                      if (data.ResponseMessage.Success) {
                        console.log(data);
                        that.dataArrayList= new Array<any>();
                        that.LoadData(1);
                        // if(){
                          // that.com.goBack();
                          
                        // }
                        // this.router.navigateByUrl("/tabs/contact/HomeSFA/add/" + this.com.getNowDatetime);
                        // that.router.navigate(["/tabs/contact/HomeSFA/type/"+that.com.getNowDatetime]);

                      } else {
                        that.msg.Alert(data.ResponseMessage.ErrorMessage);
                      }
                    }).catch(error => {
                      that.baseService.FixedSubmitBtn.isSubmitData = true;
                      console.log(error);
                    });
                  }else{
                    that.baseService.FixedSubmitBtn.isSubmitData = true;
                  }
                });
  
          }else{
            console.log('取消', '');
            for (let i=0;i<that.dataArrayList.length;i++) {
              if(that.dataArrayList[i]["orderVolume"].value>0) {
                that.dataArrayList[i]["orderVolume"].value = 0;
              }
            }
            that.LoadData(1); 
          }
        })
      } else {
        //直接搜索
        if( type==1){
          that.LoadData(1); 
        }else if(type == 2){
          let _obj = {
            value:that.month,
            format:"yyyymmdd"
          };
          that.native.IosselectDateTime(_obj).then(data=>{
            that.month = that.formatDate(data.value);
            console.log("测试");
            that.LoadData(1);
          }).catch(eror=>{
          console.log(eror);
            });
        }
  
      }
    }
       /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    const that = this;
    let arrayDataList:Array<any> = new Array<any>();
    console.log(that.dataArrayList,"数据");
    let moreZero =0;
    
    console.log("result is "+moreZero);

    if(e.keyCode == 13 || type=='search'){
      // this.LoadData(1);
      // for (let i=0;i<that.dataArrayList.length;i++) {
      //   if(that.dataArrayList[i]["orderVolume"].value>0) {
      //     console.log("dataArrayList IS");
      //     moreZero =1;
      //     continue;
      //   }
      // }
      // if (moreZero > 0){
      //   // 有修改，弹框
      //   // that.msg.Show("我有修改，可以弹框了");
      //   that.msg.Confirm("您有修改的数据未提交,点击取消将清空","取消","确定","",false).then(fail=>{
      //     if(fail){
      //           let arrayDataList:Array<any> = new Array<any>();
      //           console.log(that.dataArrayList,"数据");
      //           // return;
      //           that.dataArrayList.forEach(items=>{
      //             let c={};
      //             if(items["orderVolume"].value){//产品数量
      //               c["ID"]=items["id"].value;
      //               c["Count"]=items["orderVolume"].value;
      //               arrayDataList.push(c);
      //             }
      //           });
      //           // console.log(arrayDataList);
      //         if(arrayDataList.length<=0){
      //           that.msg.Alert("必须填写自然销量");
      //           that.baseService.FixedSubmitBtn.isSubmitData = true;
      //           return;
      //         }
      //         const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      //         let body = new WebParameterContext();
      //         body.Account = that.com.GetAccount;
      //         body.ConfigName = "NaturalSales";
      //         body.OpType = "EDITE";
      //         body.ConfigType = "view";
      //         body.RowsPerPage = app.RowsPerPage;
      //         body.PageNumber = 0;
      //         body.Client.PageName = PageName;
      //         body.Client.ApiType = "Element";
      //         body.Client.Name = that.element.name;
      //         body.Client.ClientType = 2;
      //         if (that.platform.is("android")) {
      //           body.Client.ClientType = 0;
      //         } else if (that.platform.is("ios")) {
      //           body.Client.ClientType = 1;
      //         }
      //         // body.RequestBody = {"Products":JSON.stringify(arrayDataList)};
      //         body.RequestBody = {"Products":arrayDataList};
      //         body.RequestBody["Createtime"]=that.month;//获取当前日期
      //         body.RequestBody = JSON.stringify(body.RequestBody);
      //         //  return;
      //         that.baseService.FixedSubmitBtn.isSubmitData = true;
      //           that.msg.Confirm("确定提交吗？","取消","确定","",false).then(res=>{
      //             if(res){
      //               that.http.post(app.DEFAULTURL, body).then(data => {
      //                 that.baseService.FixedSubmitBtn.isSubmitData = true;
      //                 /****判断是否第一页end****/
      //                 if (data.ResponseMessage.Success) {
      //                   console.log(data);
      //                   that.dataArrayList= new Array<any>();
      //                   that.LoadData(1);
      //                   // if(){
      //                     // that.com.goBack();
                          
      //                   // }
      //                   // this.router.navigateByUrl("/tabs/contact/HomeSFA/add/" + this.com.getNowDatetime);
      //                   // that.router.navigate(["/tabs/contact/HomeSFA/type/"+that.com.getNowDatetime]);

      //                 } else {
      //                   that.msg.Alert(data.ResponseMessage.ErrorMessage);
      //                 }
      //               }).catch(error => {
      //                 that.baseService.FixedSubmitBtn.isSubmitData = true;
      //                 console.log(error);
      //               });
      //             }else{
      //               that.baseService.FixedSubmitBtn.isSubmitData = true;
      //             }
      //           });
  
      //     }else{
      //       console.log('取消', '');
      //       for (let i=0;i<that.dataArrayList.length;i++) {
      //         if(that.dataArrayList[i]["orderVolume"].value>0) {
      //           that.dataArrayList[i]["orderVolume"].value = 0;
      //         }
      //       }
      //     }
      //   })
      // } else {
      //   //直接搜索
      //   that.LoadData(1); 
  
      // }
      that.subClick(1);
    }
  }
  /**
   * 
   * @param 日期选择
   */
  Eventdatetime(data){
    console.log(data);
    this.month = data.detail.value;
   this.LoadData(1);
  }
  preDay (dateCount) {
    //let dateCount = 2  当前日期前几天
    let date = new Date() // 获取当前时间
    date.setDate(date.getDate() - dateCount); // 设置日期为几天前
    let _y = date.getFullYear();
      let _m = date.getMonth()+1;
      let _d = date.getDate();
      return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
  }
  EventDateTimeClick(){
    console.log("测试1");
    let that = this;
    console.log(that.month);
    that.subClick(2);
  
    // for (let i = 0; i < dateCount; i++) {
    //    dateArray.push(date.getDate()) // 获取日期
    //    date.setDate(date.getDate() + 1); // 获取日期后加一天
    //  }
    // dateArray.push(date.getDate()) // 把当前日期加进去
    // console.log("获取当天日期+++++++++++++++++++++++++++")
    //     console.log(dateArray);
    // let _obj = {
    //   value:that.month,
    //   format:"yyyymmdd"
    // };
    // that.native.IosselectDateTime(_obj).then(data=>{
    //   that.month = that.formatDate(data.value);
    //   console.log("测试");
    //   that.LoadData(1);
    // }).catch(eror=>{
    // console.log(eror);
    //   });
  }
  formatDate(date){
    if(date){
      let _date = new Date(date.replace(/-/g,"/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth()+1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10?"0"+_m:_m) + "-"+(_d < 10? "0"+_d:_d);
    }else{
      return date;
    }
  }
  /**
   * 下拉刷新
   * @param event 当前对象
   */
  doRefresh(event){
    // this.LoadData(1);
    // console.log(event);
    event.target.pullMax=500;
    event.target.pullMin=100;
    // console.log(this.ionRefresh);
    event.target.complete();
  }

  /**
   * 文本框改变事件
   * @param item 当前列数据
   * @param event 对应的数据
   * @index index 对应下标
   */
  onInput(item,event,index){
    const that=this;
    let maxvalue:number=6;
   setTimeout(() => {
     if( event.target.value=="0"){
      event.target.value=null;
     }
    /**
     * 可以输入负数的判断
     */
       event.target.value=event.target.value||null;
       event.target.value = event.target.value.match(/^-?[0-9]\d*$/)|| event.target.value.match(/-?/);
       
// if(regexp.test(event.target.value)) {

// } else {
//     event.target.value = ""
// } 
    // if(!that.com.isNumberFloat(event.target.value)){
//       if (!(/(^[1-9]\d*$)/.test(event.target.value))&& !(/(^-[0-9]*[1-9][0-9]*$)/.test(event.target.value))){
//       if(!(event.target.value.replace(/[^-\d]*/g,""))){
//         if(!(event.target.value.replace(/^\-[1-9][0-9]*$/g,""))){
          
//         if(( event.target.value.match(/^-?[0-9]\d*$/)|| event.target.value.match(/-?/))){
       
//       event.target.value=0;
//     }
//   }
// }
// }
    // else{
      if(event.target.value.length-maxvalue>0){
        let len:number =event.target.value.length-maxvalue;
        event.target.value=event.target.value.substring(0,(event.target.value.length-len));
      }
    // }

   },1200);
  //  不可以输入负数
   item.orderVolume.value = event.target.value;
   console.log(item.orderVolume.value);
    console.log("自然销量");
      // if(event.target.value){
      //   let numvalue:any=that.com.GetNumber(event.target.value);
      //   if(numvalue){
      //     item.orderVolume.value = numvalue;
      //     event.target.value= numvalue;

      //    }else{
      //     event.target.value=null;
      //     item.orderVolume.value = 0;
      //   }
      // }else{
      //   event.target.value=null;
      //   item.orderVolume.value = 0;
      // }
     
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber){
    // let dateCount = 2 // 当前日期前几天
    // let date = new Date() // 获取当前时间
    // let dateArray = [] // 日期数组
    // date.setDate(date.getDate() - dateCount); // 设置日期为几天前
    // for (let i = 0; i < dateCount; i++) {
    //    dateArray.push(date.getDate()) // 获取日期
    //    date.setDate(date.getDate() + 1); // 获取日期后加一天
    //  }
    // dateArray.push(date.getDate()) // 把当前日期加进去
    // console.log("获取当天日期+++++++++++++++++++++++++++")
    //     console.log(dateArray);
    let codeRose= this.com.GetAccount.Roles;
    console.log("角色角色角色角色===============================")
    console.log(codeRose)
    console.log(codeRose[0].Code);
    let codeDetail = codeRose[0].Code;
    
    let that = this;
      // 日期实例 2020-02-19
      // let dateArray = [] // 日期数组
      // dateArray.push(this.preDay(1));
      // dateArray.push(this.preDay(0));
      // dateArray.push(this.preDay(2));

       // 日期实例 2020-02-19
       let dateArray = [] // 日期数组
       // dateArray.push(this.preDay(1));
       // dateArray.push(this.preDay(0));
       // dateArray.push(this.preDay(2));
       if(codeDetail === "1003" || codeDetail === "1002"){
         if(that.buType == "NTS" ){
           dateArray.push(this.preDay(1));
           dateArray.push(this.preDay(0));
           dateArray.push(this.preDay(2));
         } 
          if(that.buType == "Retail"){
           dateArray.push(this.preDay(0));
           dateArray.push(this.preDay(1));
           dateArray.push(this.preDay(2));
           dateArray.push(this.preDay(3));
           dateArray.push(this.preDay(4));
           dateArray.push(this.preDay(5));
           dateArray.push(this.preDay(6));
           dateArray.push(this.preDay(7));
           dateArray.push(this.preDay(8));
           dateArray.push(this.preDay(9));
           dateArray.push(this.preDay(10));
         }
          if(that.buType == "GTBBS"){
          dateArray.push(this.preDay(0));
          dateArray.push(this.preDay(1));
          dateArray.push(this.preDay(2));
          dateArray.push(this.preDay(3));
          dateArray.push(this.preDay(4));
          dateArray.push(this.preDay(5));
          dateArray.push(this.preDay(6));
          dateArray.push(this.preDay(7));
          dateArray.push(this.preDay(8));
          dateArray.push(this.preDay(9));
          dateArray.push(this.preDay(10));
        }
       }
      
       console.log(dateArray,"xainshi")
      let haveDay  = false;
      for (let ind=0;ind<dateArray.length;ind++) {
        console.log("对比结果是")
        if (that.month === dateArray[ind]) {
          haveDay = true;
        }
      }
      if(codeDetail === "1003"){
        that.haveDate = true;
        that.baseService.FixedSubmitBtn.isShow = false;

      }
      else{
        if(haveDay){
          that.haveDate = false;
          that.baseService.FixedSubmitBtn.isShow = true;

        }else{
          that.haveDate = true;
          that.baseService.FixedSubmitBtn.isShow = false;

        }
      }
      console.log(haveDay?"日期两天内":"日期两天外")
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    console.log("123456");
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
      console.log(body.ConfigName);
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    console.log("显示显示");
    console.log(that.element.selectItemList.selectItem);
    // if(that.searchValue){
    //   let selectItem = that.element.selectItemList.selectItem;
    //   if(selectItem.length > 0){
    //     selectItem.forEach(item=>{
    //       if(item.elementType && item.elementType=="Search") {
    //         body.RequestBody[item.field] = that.com.LikeSearch(that.searchValue.trim());
    //         console.log("显示数据显示数据")
    //         console.log(body.RequestBody[item.field])
    //       }
    //     })
    //   }
    // }
    body.RequestBody={"time":that.month};
    if(that.searchValue){
      // let _obj={
      //   ProductName:that.com.LikeSearch(that.searchValue.trim())
      // };
      // body.RequestBody["ProductName"]=that.com.LikeSearch(that.searchValue.trim());
      body.RequestBody["ProductName"]=that.searchValue.trim();
    }
    body.RequestBody=JSON.stringify(body.RequestBody);
   

    // let _obj={};
    //      _obj["c_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    //     _obj["c_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore")["ID"];
        // body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              let v:any = item[element.field];
              if(typeof(item[element.field])=="undefined"){
                 v=null;
              }
              objfield[element.bindingField] = { "value": v, "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          console.log( that.dataArrayList,"产品显示显示");
          that.dataArrayList.forEach(item=>{
            
          })
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        if(that.dataArrayList.length > 0){
          that.Remark = that.dataArrayList[0]["Remark"]["value"];
        }
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
      that.dataArrayList = [];
      that.PageNumber = 1;
    });
 }
 /**
  * 礼品选择弹窗
  */
 async presentModal(){
   let that =this;
   let ids:Array<string>=new Array<string>();
   that.base.GridArrayData.forEach(item=>{
    console.log(item.id)
    ids.push(item.id);
   })
   let checkitem:Array<any>=new Array<any>();
   that.tempGridList.forEach(temp=>{
     checkitem.push({"id":temp.id,"Name":temp.Name,"Code":temp.Code,"Num":temp.Num,"pid":temp.pid});
     console.log("checkitem++++++++++++++++++")
     console.log(checkitem)
   });
   let _obj:any={
    component: PublicselectionPage,
    componentProps: {
      "ids": ids,
      "checkItem":checkitem,
      "checked":that.ischeckAll,
      "typeItem": 1,
      "codetype":2
    }
  };
  //  if(that.com.GetAccount.BuType!="NTS"){
  //   _obj["diszrxl"]=true;
   
  //  }
   const modal = await that.modalCtrl.create(_obj);
  await modal.present();
  const { data } = await modal.onWillDismiss();
  console.log(data);
  that.lpArrayList=[];
  if(data.result.ResponseMessage.Success){
     let tempList:Array<any>=new Array<any>();
          tempList=data.result.Status;
          that.ischeckAll=data.checked;
      // that.base.GridGiftCount=0;
      that.tempGridList=tempList;
      // that.tempGridList.forEach(item=>{
      //   if(that.lpArrayList.find(proc=>proc.id==item.id)){
      //     that.lpArrayList.find(proc=>proc.id==item.id).NewNum+=item.Num;
      //   }else{
      //     item.NewNum=item.Num;
      //     that.lpArrayList.push(item);
      //   }
      // });
      
  }
  console.log(data,"onWillDismiss");

 }
  /**
   * 底部弹出删除
   */

  presentActionShee(itmid,index){
    const that = this;
    // debugger;
    that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
      if(fit){
        // if(that.tempGridList.length >0){
        //   let _index=that.tempGridList.length;
        //   while(_index--){
        //     if(that.tempGridList[_index].id == itmid.id){
        //       that.tempGridList.splice(_index, 1); 
        //     }
        //   }
        //   if(that.com.GetStorageKey("homing")){
        //     localStorage.setItem("homing",JSON.stringify(that.tempGridList));
        //   }
        // }
        // if(that.lpArrayList.length >0){
        //   that.lpArrayList.splice(index,1);
        //   if(that.com.GetStorageKey("lpArrayList")){
        //     localStorage.setItem("lpArrayList",JSON.stringify(that.lpArrayList));
        //   }
        // }

        if(that.tempGridList.length >0){
          that.tempGridList.splice(index,1);
          if(that.com.GetStorageKey("tempGridList")){
            localStorage.setItem("tempGridList",JSON.stringify(that.tempGridList));
          }
        }

      }
    });
    }
    BindActivityInfo(){
      const that =this;
      that.activityListArray=[];
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "GetActivityList";
      body.OpType = "query";
      body.ConfigType = "form";
      // body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 0;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 0;
      body.RequestBody = JSON.stringify({"telPhone": ""})
      that.http.post(app.DEFAULTURL, body).then(data => {
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
         that.activityListArray=data.Status.Datas||[];
        } else {
          console.log(data.ResponseMessage.ErrorMessage,"拉去活动列表失败");
        }
      }).catch(error => {
      console.log(error,"拉去活动列表失败");
      });
    }
    async presentModaldifferences() {
      var that=this;
      // debugger;
      const modal = await this.modalCtrl.create({
        component: ListofActivitiesPage,
        cssClass: 'listof-activities',
        componentProps: {
          "type":"自然销量",
          "activityListArrayList":that.activityListArray, 
          "activeID":that.activityID
        }
      });
        await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data)
      if(data.seceltName){
        that.activityName = data.seceltName;
        that.activityID = data.FK_TBReasonsProductInventoryDifferences_ID;
      }
      console.log(data.cravingforRemk)
     console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
    }
    // 清楚选择的活动
  cleashideModal(){
    const that=this;
    that.activityName ="请选择活动";
    that.activityID ="";
  }
        /**
   * 确认下单之前判断
   */
  EventClickBefore(): Promise<WebResponesContext>{
    const that = this;
    console.log("自然销量");
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let  respone:WebResponesContext=new WebResponesContext();
      let DataList: Array<any> = new Array<any>();
      let lpArray:Array<any>=new Array<any>();//礼品列表
     //#region 产品列表
      that.dataArrayList.forEach(item => {
        if (!(/(^[1-9]\d*$)/.test(item["orderVolume"].value))&& !(/(^-[0-9]*[1-9][0-9]*$)/.test(item["orderVolume"].value))){
          return;
      }
        let array = {};
        if(item["orderVolume"].value){
          array["a_FK_TBProductInformation_ID"] = item["id"].value;
        array["a_Num"] = item["orderVolume"].value;
        array["a_productCode"] = item["code"].value;
        // array["a_FK_TBActivity_ID"] =that.activityID;
        array["IntegralCodeDetailList"]=[];
        DataList.push(array);
        }//产品数量
        
      });
     //#endregion
      //#region  礼品
        that.tempGridList.forEach(p=>{
          let c:any={};
          c["id"]=p.id;
          c["Stock"]=p.Stock;
          c["Code"]=p.Code;
          c["Num"]=p.Num;
          lpArray.push(c);
        });
      //#endregion
      // if(that.buType=="NTS"){
      //   if(DataList.find(t=>t.a_Num<0)){
      //     that.msg.Alert("自然销售已无法做负销量，如果您需求退单，请在退单流程中进行退单操作。");
      //      return;
      //   }
      //   if(lpArray.find(t=>t.Num<0)){
      //     that.msg.Alert("自然销售已无法做负销量，如果您需求退单，请在退单流程中进行退单操作。");
      //      return;
      //   }
      // }
     
      // debugger;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "CheckProductPurchase";
  body.OpType = "add";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  let _obj={"giftData":lpArray,"productData":DataList,"memberID":null,"OrderEntry":"3"};
  if(that.com.GetStorageKey("meminfo")){
    _obj["memberID"]= that.com.GetStorageKey("meminfo")["id"].value;
  }
  _obj["a_FK_TBActivity_ID"]= that.activityID;//活动ID
  body.RequestBody = JSON.stringify(_obj);
 
  respone.Status=body;
  respone.ResponseMessage.Success=true;
  respone.ResponseMessage.ErrorMessage="";
      that.msg.Loading("数据请求中...").then(loads=>{
        that.http.post(app.DEFAULTURL, body).then(data => {
          loads.dismiss();
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            resolve(respone);
          } else {
            respone.ResponseMessage.Success=false;
            respone.ResponseMessage.ErrorMessage=data.ResponseMessage.ErrorMessage;
            reject(respone);
          }
        }).catch(error => {
          loads.dismiss();
          respone.ResponseMessage.Success=false;
          respone.ResponseMessage.ErrorMessage="系统异常请联系管理员";
          reject(respone);
        });
          loads.present();
      });
    });
  }
  /**
   * 提交数据
   */
  EventClick(){
    const that =this;
    let arrayDataList:Array<any> = new Array<any>();
    let gitDatalist:Array<any> = new Array<any>();
    console.log(that.dataArrayList,"数据");
    // return;
    that.DisabledSubmit = true;
    that.dataArrayList.forEach(items=>{
      console.log(items,"显示数据显示数据");
    
      if (!(/(^[1-9]\d*$)/.test(items["orderVolume"].value))&& !(/(^-[0-9]*[1-9][0-9]*$)/.test(items["orderVolume"].value))){
          return;
      }
      let c={};
      if(items["orderVolume"].value){//产品数量
        c["ID"]=items["id"].value;
        c["Count"]=items["orderVolume"].value;
        arrayDataList.push(c);
      }
    });
    that.tempGridList.forEach(itp=>{
      let gif={};
      gif["ID"]= itp.id;
      gif["Count"]= itp.Num;
      gitDatalist.push(gif);
    })
    // console.log(arrayDataList);
    console.log(gitDatalist,"礼品");
    console.log(arrayDataList,"数据数据");
    // return;
  if(arrayDataList.length<=0){
    that.msg.Alert("必须填写自然销量");
    that.baseService.FixedSubmitBtn.isSubmitData = true;
    return;
  }
 
  // if(arrayDataList.length > 0 && !that.Remark){
  //   that.msg.Alert("必须填写备注");
  //   that.baseService.FixedSubmitBtn.isSubmitData = true;
  //   return;
  // }
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "NaturalSales";
  body.OpType = "EDITE";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  // body.RequestBody = {"Products":JSON.stringify(arrayDataList)};
  body.RequestBody = {"Products":arrayDataList,"Gifts":gitDatalist};
  body.RequestBody["Createtime"]=that.month;//获取当前日期
  body.RequestBody["OrderEntry"]="3";
  body.RequestBody["a_FK_TBActivity_ID"]= that.activityID;//活动ID
  body.RequestBody = JSON.stringify(body.RequestBody);
  //  return;
  that.baseService.FixedSubmitBtn.isSubmitData = true;
  that.EventClickBefore().then(data=>{
    that.msg.Confirm("确定提交吗？","取消","确定","",false).then(res=>{
      if(res){
        that.http.post(app.DEFAULTURL, body).then(data => {
          that.baseService.FixedSubmitBtn.isSubmitData = true;
          that.DisabledSubmit = true;
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            console.log(data);
            
            // if(){
              that.msg.Alert("自然销量成功").then(data=>{    
                if(data){
                  that.dataArrayList= new Array<any>();
                  that.com.goBack();
                }
             })
              
            // }
            // this.router.navigateByUrl("/tabs/contact/HomeSFA/add/" + this.com.getNowDatetime);
            // that.router.navigate(["/tabs/contact/HomeSFA/type/"+that.com.getNowDatetime]);

          } else {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          }
        }).catch(error => {
          that.DisabledSubmit = false;
          that.baseService.FixedSubmitBtn.isSubmitData = true;
          console.log(error);
        });
      }else{
        that.baseService.FixedSubmitBtn.isSubmitData = true;
      }
    });
  }).catch(err=>{
    that.msg.Confirm("确认下单吗？","取消","确定","",false,true).then(res=>{
      if(res){
      }
    });
  });
  }
    /**
   * 加载类型的列表
   * @param num 对应列表
   */
  btn_change(itm){
    // this.num =1;
    const that=this;
  //  that.num = itm;
   if(that.step == itm){
    that.step = 1;
  }else{
    that.step = itm;
  }
    
   
  }
  allTo(): void {
    if (this.allcnter === true) {
        this.allcnter = false;
    } else {
        this.allcnter = true;
    }

}
allonly (num): void {
    console.log(num);
    switch (num) {
        case 1 :
            this.allnumber = '全部';
            this.allcnter = false;
            break;

        case 2 :
            this.allnumber = '产品类别名称';
            this.allcnter = false;
            break;

        case 3 :
            this.allnumber = '产品系列名称';
            this.allcnter = false;
            break;

        case 4 :
            this.allnumber = '产品阶段名称';
            this.allcnter = false;
            break;
        default:
            this.allnumber = '全部';
    }
}
allTo1(): void {
  if (this.allcnter1 === true) {
      this.allcnter1 = false;
  } else {
      this.allcnter1 = true;
  }

}
allonly1 (num): void {
  console.log(num);
  switch (num) {
      case 1 :
          this.allnumber1 = '全部';
          this.allcnter1 = false;
          break;

      case 2 :
          this.allnumber1 = '产品类别名称';
          this.allcnter1 = false;
          break;

      case 3 :
          this.allnumber1 = '产品系列名称';
          this.allcnter1 = false;
          break;

      case 4 :
          this.allnumber1 = '产品阶段名称';
          this.allcnter1 = false;
          break;
      default:
          this.allnumber1 = '全部';
  }
}
allTo2(): void {
  if (this.allcnter2 === true) {
      this.allcnter2 = false;
  } else {
      this.allcnter2 = true;
  }

}
allonly2 (num): void {
  console.log(num);
  switch (num) {
      case 1 :
          this.allnumber2 = '全部';
          this.allcnter2 = false;
          break;

      case 2 :
          this.allnumber2 = '产品类别名称';
          this.allcnter2 = false;
          break;

      case 3 :
          this.allnumber2 = '产品系列名称';
          this.allcnter2 = false;
          break;

      case 4 :
          this.allnumber2 = '产品阶段名称';
          this.allcnter2 = false;
          break;
      default:
          this.allnumber2 = '全部';
  }
}
}
